<template>
    <div>
        <div class="message_design text-center" v-if="this.$store.state.docusignAccessToken && JSON.parse(this.$store.state.docusignAccessToken).access_token">
            <span>Please wait while initializing DocuSign</span>
        </div>
        <div v-else-if="error" class="message_design_error text-center">
            Error : {{error}}
        </div>
        <div v-else class="message_design text-center">
            <span>Please wait while authorising user</span>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Complete registration with DocuSign 
                        </h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            An email has been sent to {{ JSON.parse(this.$store.state.user).email }}. Please review and sign the documents with DocuSign.
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-default btn1"
                            data-dismiss="modal"
                            @click="closeTab()"
                        >
                            CONTINUE
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import {mapActions} from 'vuex'
export default {
    name: "DocusignAuthPage",
    data () {
        return {
            code : null,
            errorStatus: false,
            error: null,
            type:null
        }
    },
    methods: {
        ...mapActions(["getDocusignAccessToken"]),

        respVerifyDocuSignEmail() {
            this.loading = false;
            $("#myModal").modal("show");
        },

        closeTab() {
            window.open(
                "https://financialdataexchange.org/",
                "_self"
            );
        },
    },
    created() {
        this.$store.state.pageState = "thankyou";
        if(this.$route.query.state){
            this.type = this.$route.query.state;
        }
        if(this.$route.query.error){
            this.errorStatus = true;
            this.error = this.$route.query.error;
            this.code = null;
        }else if(this.$route.query.code){
            this.code = this.$route.query.code;
            this.errorStatus = false;

            let req = {
                "code" : this.code,
                "type" : this.type
            }
            this.getDocusignAccessToken(req);
        }

    }
}
</script>
<style scoped>
.message_design {
  background-color: #0f8575;
  color: white;
  padding: 50px;
  margin: 20px;
  margin-bottom: 240px;
  font-size:20px
}

.message_design_error {
  background-color: #ff0000;
  color: white;
  padding: 50px;
  margin: 20px;
  margin-bottom: 240px;
  font-size:20px
}

.modal-title {
    font-size: 20px;
    line-height: 22px;
    color: #1978a0;
}

.modal-body {
    font-size: 14px;
    line-height: 20px;
    color: #5a7d95;
    text-align: left;
}

.btn1 {
    background: #019382;
    border-radius: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    width: 138px;
    height: 45px;
}
</style>